// extracted by mini-css-extract-plugin
export default {"gameDesc":"GameDesc_gameDesc__r6U+D","img":"GameDesc_img__PbhFh"};